import { api } from "./axios";

export const getUsers = () => api.get("/api/users").then((r) => r.data);
export const createUser = (payload) => api.post("/api/users", payload).then((r) => r.data);
export const updateUser = (id, payload) => api.put(`/api/users/${id}`, payload).then((r) => r.data);
